/*
      _ ____     ____            _    _
     | / ___|   / ___|___   ___ | | _(_) ___  ___
  _  | \___ \  | |   / _ \ / _ \| |/ / |/ _ \/ __|
 | |_| |___) | | |__| (_) | (_) |   <| |  __/\__ \
  \___/|____/   \____\___/ \___/|_|\_\_|\___||___/
==================================================
= Functions to create cookies.                   =
= You can read,create and erase cookies.         =
= Examples :                                     =
= createCookie('popupOpen','cookieOpen',7);      =
==================================================
*/

function createCookie(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name,"",-1);
}
